<template>
    <div
        :class="classes"
        class="poster"
    >
        <Badge
            v-if="badge"
            :variant="badge.variant"
            class="poster__badge"
        >
            {{ badge.text }}
        </Badge>
        <div
            v-if="src"
            class="poster__image"
        >
            <BaseImg
                :src="src"
                :resolve="resolveSrc"
            />
        </div>
        <div class="poster__card">
            <div class="poster__content">
                <slot name="content"></slot>
            </div>
            <div class="poster__footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        src: String,
        badge: Object,
        resolveSrc: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        classes() {
            return this.inline ? ['poster--inline'] : [];
        }
    }
}
</script>

<style>
.poster {
    @apply relative;
    z-index: 1;

    &--inline {
        @screen lg {
            @apply flex bg-zircon;
        }

        .poster__image {
            @screen lg {
                @apply w-1/2;
            }
        }

        .poster__card {
            @screen lg {
                @apply w-1/2;
            }
        }
    }

    &__badge {
        @apply absolute top-0 left-0 z-10 uppercase;
        letter-spacing: 2px;
    }

    &__card {
        @apply flex flex-col border border-midnight;
    }

    &__content {
        @apply flex-grow p-5;
        min-height: 160px;
    }

    &__footer {
        @apply flex justify-between px-5 py-3 border-t border-midnight;
    }
}
</style>
